export default __webpack_public_path__ + "static/media/Edenred-EMP-banner-lunch.81b2446c.jpg";